// React import ve AutoFixHighIcon kaldırıldı: kullanılmıyor, lint uyarılarını temizlemek için

// ESKI SERVIS VERISI - YORUM SATIRINA ALINDI (gelecekte kullanım için)
/*
export const servicesData = [
  {
    id: 1,
    title: 'Talep Tahmini',
    description: 'Gelecekteki ürün taleplerini yapay zeka ile tahminleyerek stok ve tedarik süreçlerini optimize edin.',
    path: '/talep-tahmini',
    category: 'Yapay Zeka',
    image: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=800&auto=format&fit=crop&q=60',
    sectors: ['retail', 'manufacturing']
  },
  // ... diğer eski servisler
];
*/

// YENİ ÜRÜN VE ÇÖZÜM YAPISI
export const servicesData = [
  // D-CAT ÜRÜNLER
  {
    id: 'chat-cat',
    title: 'Chat-CAT',
    description: 'Kurumsal Yapay Zeka Asistanı',
    path: '/products/chat-cat',
    category: 'D-CAT Ürün',
    image: 'https://images.unsplash.com/photo-1531747118685-ca8fa6e08806?w=800&auto=format&fit=crop&q=60',
    sectors: ['all']
  },
  {
    id: 'trend-cat',
    title: 'Trend-CAT',
    description: 'E-Ticaret Trend Analizi',
    path: '/products/trend-cat',
    category: 'D-CAT Ürün',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&auto=format&fit=crop&q=60',
    sectors: ['all']
  },

  // D-CAT YAPAY ZEKA ÇÖZÜMLERİ
  // AI POC Çalışması - Banner olarak Home.jsx'te gösteriliyor, kartlardan kaldırıldı
  /*
  {
    id: 'ai-poc-demo',
    title: 'AI POC Çalışması',
    description: 'Zaman serisi tahminleme ve yapay zeka POC demo çalışması',
    path: '/services/ai-poc-demo',
    category: 'Yapay Zeka Çözümü',
    image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?q=80&w=2070&auto=format&fit=crop&q=60',
    sectors: ['all']
  },
  */
  {
    id: 'hr-assistant',
    title: 'İK Dijital Asistanı',
    description: 'İK Süreçlerini otomatikleştiren yapay zeka asistanı',
    path: '/solutions/hr-assistant',
    category: 'Yapay Zeka Çözümü',
    image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&auto=format&fit=crop&q=60',
    sectors: ['hr', 'management']
  },
  {
    id: 'retail-customer-experience-assistant',
    title: 'Mağaza Deneyim Asistanı',
    description: 'Müşteri taleplerini cevaplayan ve aksiyonlar alan mağaza deneyim asistanı',
    // Yol, App.js içindeki Route ile eşleştirildi
    path: '/solutions/retail-customer-experience-assistant',
    category: 'Yapay Zeka Çözümü',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&auto=format&fit=crop&q=60',
    sectors: ['retail']
  },
  {
    id: 'financial-assistant',
    title: 'Finansal Dijital Asistanı',
    description: 'SQL veritabanındaki bilgilerden finansal soruları cevaplayan yapay zeka asistanı',
    path: '/solutions/financial-assistant',
    category: 'Yapay Zeka Çözümü',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&auto=format&fit=crop&q=60',
    sectors: ['finance']
  },
  /*
  {
    id: 'logistics-optimization',
    title: 'Depo ve Lojistik Optimizasyonu',
    description: 'Rota planlama ve depo operasyonlarını yapay zeka ile optimize edin',
    path: '/solutions/logistics-optimization',
    category: 'Yapay Zeka Çözümü',
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&auto=format&fit=crop&q=60',
    sectors: ['logistics', 'warehouse']
  },
  */
  {
    id: 'franchise-management',
    title: 'Franchise Destek Asistanı',
    description: 'Bayilik ve franchise süreçlerini optimize eden dijital asistan',
    path: '/solutions/franchise-management',
    category: 'Yapay Zeka Çözümü',
    image: 'https://images.unsplash.com/photo-1681505531034-8d67054e07f6?q=80&w=2070&auto=format&fit=crop&q=60',
    sectors: ['franchise', 'management']
  },
  {
    id: 'demand-forecasting',
    title: 'Talep Tahminleme ve Stok Optimizasyonu',
    description: 'Geçmiş verilerden gelecekteki satış ve stok ihtiyacını tahminleyen yapay zeka çözümü',
    path: '/solutions/demand-forecasting',
    category: 'Yapay Zeka Çözümü',
    image: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=800&auto=format&fit=crop&q=60',
    sectors: ['retail', 'manufacturing']
  },

  {
    id: 'social-sentiment',
    title: 'App Store / Play Store Duygu ve Marka Algı Analizi',
    description: 'Müşteri yorumlarından yapay zeka ile duygu analizi yapılması ve raporlanması',
    path: '/solutions/social-sentiment',
    category: 'Yapay Zeka Çözümü',
    image: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=800&auto=format&fit=crop&q=60',
    sectors: ['marketing', 'social-media']
  },
  /*
  {
    id: 'vehicle-segmentation',
    title: 'Araç Segmentasyon ve Satış Analizi',
    description: 'Otomotiv sektörü için araç segmentasyonu ve satış analiz sistemi',
    path: '/solutions/vehicle-segmentation',
    category: 'Yapay Zeka Çözümü',
    image: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800&auto=format&fit=crop&q=60',
    sectors: ['automotive']
  },
  */
  {
    id: 'document-ai',
    title: 'Akıllı Döküman Anlama ve Veri Dönüştürme Analizi',
    description: 'Dokümanları anlayarak veriye dönüştüren yapay zeka doküman işleme sistemi',
    path: '/solutions/document-ai',
    category: 'Yapay Zeka Çözümü',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&auto=format&fit=crop&q=60',
    sectors: ['document-processing', 'automation']
  },
  {
    id: 'it-helpdesk-ai',
    title: 'Yapay Zeka Destekli BT Çağrı Otomasyon ve Biletleme Sistemi',
    description: 'BT destek süreçlerini otomatikleştiren yapay zeka çözümü',
    path: '/solutions/it-helpdesk-ai',
    category: 'Yapay Zeka Çözümü',
    image: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=800&auto=format&fit=crop&q=60',
    sectors: ['it-support', 'automation']
  }

  // ESKI POC ÇALIŞMASI - YORUM SATIRINA ALINDI (gelecekte kullanım için)
  /*
  {
    id: 'ai-poc-demo',
    title: 'AI POC Çalışması',
    description: 'Duygu analizi ve tepki önerisi POC çalışması',
    category: 'nlp',
    categoryName: 'Doğal Dil İşleme',
    icon: <AutoFixHighIcon />,
    iconBgColor: '#9c27b0',
    image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?q=80&w=2070',
    path: '/services/ai-poc-demo'
  }
  */
];

// Talep Tahmin verisi - export edildi
export const talepTahminiData = {
  lineChart: [
    { month: 'Ocak', gerçek: 4000, tahmin: 4100 },
    { month: 'Şubat', gerçek: 3000, tahmin: 3200 },
    { month: 'Mart', gerçek: 2000, tahmin: 2100 },
    { month: 'Nisan', gerçek: 2780, tahmin: 2700 },
    { month: 'Mayıs', gerçek: 1890, tahmin: 1950 },
    { month: 'Haziran', gerçek: 2390, tahmin: 2400 },
  ],
  accuracyMetrics: {
    mape: '4.2%',
    rmse: '120.5',
    accuracyRate: '95.8%'
  },
  businessImpact: {
    stockReduction: '18%',
    serviceLevel: '99.2%',
    costSavings: '₺520,000'
  },
  caseStudies: [
    {
      company: 'X Market Zinciri',
      challenge: 'Ürün stok yönetiminde zorluklar',
      solution: 'ML tabanlı talep tahmin modeli',
      results: 'Stok maliyetlerinde %22 azalma, raf boşluk oranında %35 azalma'
    }
  ]
};

// ESKI VERİLER - YORUM SATIRINA ALINDI (gelecekte kullanım için)
/*
// Talep Tahmin verisi
export const talepTahminiData = {
  lineChart: [
    { month: 'Ocak', gerçek: 4000, tahmin: 4100 },
    { month: 'Şubat', gerçek: 3000, tahmin: 3200 },
    { month: 'Mart', gerçek: 2000, tahmin: 2100 },
    { month: 'Nisan', gerçek: 2780, tahmin: 2700 },
    { month: 'Mayıs', gerçek: 1890, tahmin: 1950 },
    { month: 'Haziran', gerçek: 2390, tahmin: 2400 },
  ],
  accuracyMetrics: {
    mape: '4.2%',
    rmse: '120.5',
    accuracyRate: '95.8%'
  },
  businessImpact: {
    stockReduction: '18%',
    serviceLevel: '99.2%',
    costSavings: '₺520,000'
  },
  caseStudies: [
    {
      company: 'X Market Zinciri',
      challenge: 'Ürün stok yönetiminde zorluklar',
      solution: 'ML tabanlı talep tahmin modeli',
      results: 'Stok maliyetlerinde %22 azalma, raf boşluk oranında %35 azalma'
    }
  ]
};
*/
